import api from "../utils/api";

export const getPEOPLE = (data) => {
  return api.get(process.env.VUE_APP_DADOSCOMPLEMENTARES_API + "?cpf=" + data);
};
